import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'

import PrismicVue from '@prismicio/vue'
import linkResolver from './link-resolver'
import htmlSerializer from './utilities/html-serializer'

Vue.use(PrismicVue, {
  endpoint: "https://felixdesignportfolio.cdn.prismic.io/api/v2",
  linkResolver: linkResolver,
  htmlSerializer: htmlSerializer
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Vue.prototype.$map = (in_min, in_max, out_min, out_max) => {
  return (this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}